var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-container"},[(_vm.userInfo.is_confirm !== 0)?_c('has-sure-card',{attrs:{"userInfo":_vm.userInfo,"dataFlowObj":_vm.dataFlowObj}}):_vm._e(),(_vm.userInfo.is_confirm === 0)?_c('not-sure-card',{attrs:{"userInfo":_vm.userInfo,"dataFlowObj":_vm.dataFlowObj}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }